import {
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IQuickBooksTimeSetupFieldsPanel {
}
export const QuickBooksTimeSetupFieldsPanel: FC<
	IQuickBooksTimeSetupFieldsPanel
> = ({ }) => {

	return (
		<>
			<RHookFormTextFieldWithLabel
				label="Access Token"
				id="access_token"
				testId={`access-token`}
				labelPosition={LabelPosition.Top}
			/>
		</>
	);
};
